import type {
  CouponPrizePayload,
  LuckyNumberPrizePayload,
  NonePrizePayload,
  PixPrizePayload,
  RoulettePrizeSlotInput,
  RoulettePrizeType,
} from '@/lib/roulette'
export interface RoletaSlotState {
  position: number
  prize_type: RoulettePrizeType
  probability: number
  prize_payload:
    | CouponPrizePayload
    | LuckyNumberPrizePayload
    | PixPrizePayload
    | NonePrizePayload
    | null
}

export { rouletteProbabilityToPercent } from '@/lib/rouletteProbability'

export function emptyPayload(
  prizeType: RoulettePrizeType
): CouponPrizePayload | LuckyNumberPrizePayload | PixPrizePayload | NonePrizePayload | null {
  switch (prizeType) {
    case 'coupon':
      return {
        description: '',
        discount_percent: undefined,
        discount_amount: undefined,
        min_purchase: undefined,
        valid_until: undefined,
      }
    case 'lucky_number':
      return { quantity: 1 }
    case 'pix':
      return { amount: 0 }
    case 'none':
      return { label: '😞' }
    default:
      return null
  }
}

/**
 * Mantém slots por posição 1..newPositions; novas posições viram "sem prêmio" com probabilidade 0.
 */
export function reconcileSlots(prev: RoletaSlotState[], newPositions: number): RoletaSlotState[] {
  if (newPositions < 2) return []
  const byPosition = new Map<number, RoletaSlotState>()
  for (const s of prev) {
    if (s.position >= 1 && s.position <= newPositions) {
      byPosition.set(s.position, { ...s, position: s.position })
    }
  }
  const result: RoletaSlotState[] = []
  for (let pos = 1; pos <= newPositions; pos++) {
    const existing = byPosition.get(pos)
    if (existing) {
      result.push(existing)
    } else {
      result.push({
        position: pos,
        prize_type: 'none',
        probability: 0,
        prize_payload: emptyPayload('none'),
      })
    }
  }
  return result
}

export function buildSlotInput(s: RoletaSlotState): RoulettePrizeSlotInput {
  return {
    position: s.position,
    prize_type: s.prize_type,
    probability: s.probability,
    prize_payload: s.prize_payload ?? undefined,
  }
}
